import { MenuItem, SelectChangeEvent } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LanguagesList } from 'core/enums/common';

import * as Styled from './styled';

const languageList = Object.keys(LanguagesList);

export const LanguageSelect = () => {
	const { i18n } = useTranslation();

	const [selectedLanguage, setSelectedLanguage] = useState<string>(
		languageList.includes(i18n?.language) ? i18n?.language : 'en'
	);

	const handleChange = (event: SelectChangeEvent<unknown>): void => {
		const value = event.target.value as string;
		setSelectedLanguage(value);
		i18n.changeLanguage(value);
		window.localStorage.setItem('i18nextLng', value);
	};

	return (
		<Styled.CustomSelect value={selectedLanguage} onChange={handleChange}>
			<MenuItem value="en">EN</MenuItem>
			<MenuItem value="ar">AR</MenuItem>
		</Styled.CustomSelect>
	);
};
